import { createGlobalStyle } from "styled-components";

const GlobalStyles = createGlobalStyle`
  html {
    background-color: #aaa;
  }
  body {
    display: flex;
    justify-content: center;
  }
  button, a {
    color: inherit;
  }
`;

export default GlobalStyles;
